import React from 'react';
import styles from './PageTitle.module.scss';

interface PageTitleProps {
  title: string;
}

export const PageTitle = ({ title }: PageTitleProps) => <h1 className={styles.title}>{title}</h1>;
